import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e426b10c")

_pushScopeId("data-v-e426b10c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("会社コード")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_dialog = _resolveComponent("cus-dialog")
  const _component_Kaisha = _resolveComponent("Kaisha")
  const _component_select_dialog = _resolveComponent("select-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_cus_dialog, {
      title: _ctx.title,
      operation: _ctx.operation,
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearForm())),
      onOperate: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCreateOrUpdate())),
      processing: _ctx.loading,
      width: "700px"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          size: "small",
          "label-position": "top",
          inline: ""
        }, {
          default: _withId(() => [
            (_ctx.operation === _ctx.DialogGenre.Edit)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "会社グループID",
                  prop: "groupId"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.groupId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.groupId = $event)),
                      maxlength: "6",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "会社グループ名",
              prop: "groupNm"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.groupNm,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.groupNm = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "会社コード",
              prop: "kaishaCd",
              class: "xl-input"
            }, {
              label: _withId(() => [
                _createVNode(_component_el_link, {
                  icon: 
                _ctx.operation === _ctx.DialogGenre.Edit ? '' : 'el-icon-edit-outline'
              ,
                  onClick: _withModifiers(_ctx.handleSelect, ["prevent"]),
                  disabled: _ctx.operation === _ctx.DialogGenre.Edit
                }, {
                  default: _withId(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["icon", "onClick", "disabled"])
              ]),
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.kaishaCd,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.kaishaCd = $event)),
                  disabled: ""
                }, {
                  append: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.form.kaishaNm), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "運用区分",
              prop: "unyoNm"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.unyoNm,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.unyoNm = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.operation === _ctx.DialogGenre.Edit)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "無効フラグ",
                  prop: "mukoFlg"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.form.mukoFlg,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.mukoFlg = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.operation === _ctx.DialogGenre.Edit && _ctx.form.mukoDate)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "無効日時",
                  prop: "mukoDate"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.mukoDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.mukoDate = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "operation", "modelValue", "processing"]),
    _createVNode(_component_select_dialog, {
      title: "会社選択",
      onCancel: _ctx.handleCloseDialog,
      modelValue: _ctx.selectDialogVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectDialogVisible = $event))
    }, {
      default: _withId(() => [
        _createVNode(_component_Kaisha, {
          isDialogMode: true,
          onSelect: _ctx.handleSelectInfo
        }, null, 8, ["onSelect"])
      ]),
      _: 1
    }, 8, ["onCancel", "modelValue"])
  ]))
})